import { InsureIQApiClient } from '@harvestiq/insureiq-api-client'

export const insureIQApiClient = new InsureIQApiClient({
  authMethod: 'cookie',
})
